import { AccordionItem, AccordionItemContent } from '@e3dc-react/shell/Elements/Accordion'
import { SmartMeterGateway } from './SmartMeterGateway'
import React from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import useAccordionStyle from 'src/Libs/styles'
import { useInstallationIsGerman } from 'src/Libs/flow/installation/hooks'
import { Emc } from './Emc'
import { useWatch } from 'react-hook-form'
import { FormSectionTitle } from 'src/Libs/flow/components'
import { useSectionFormStatus } from '../../hooks'

const EmcAndSmartMeterGateway: React.FC = () => {
  const { t } = useCustomTranslation()
  const { classes } = useAccordionStyle()
  const isInstallationGerman = useInstallationIsGerman()
  const emc = useWatch({ name: 'emcDevice' })
  const { isDirty, isError } = useSectionFormStatus(
    dirtyFields => [dirtyFields.emcDevice],
    errors => [errors.emcDevice]
  )

  if (emc === null) return null
  return (
    <AccordionItem
      title={<FormSectionTitle name={t('installation.configOverview.emcAndSmartMeterGateway')} isDirty={isDirty} isError={isError} />}
      expanded
      className={classes.accordion}
      sx={{ margin: 0 }}
    >
      <AccordionItemContent variant="paper">
        <Emc />
        {isInstallationGerman && <SmartMeterGateway />}
      </AccordionItemContent>
    </AccordionItem>
  )
}

export default EmcAndSmartMeterGateway
